import { render, staticRenderFns } from "./main-change-password.vue?vue&type=template&id=d9698dd2&scoped=true&"
import script from "./main-change-password.vue?vue&type=script&lang=ts&"
export * from "./main-change-password.vue?vue&type=script&lang=ts&"
import style0 from "./main-change-password.vue?vue&type=style&index=0&id=d9698dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9698dd2",
  null
  
)

export default component.exports